/** Human-facing names never change stored routine identity or rotation codes. */
export function routineLabel(template: {code:string;name:string}) {
  const homeDay = /^HOME-D([123])$/.exec(template.code);
  return homeDay ? `Day ${homeDay[1]}` : template.code.length <= 2 ? `Workout ${template.code}` : template.name;
}
export function routineBadge(template: {code:string;name:string}) {
  const homeDay = /^HOME-D([123])$/.exec(template.code);
  return homeDay ? homeDay[1] : template.code.length <= 2 ? template.code : '✓';
}
